module.exports = "<div id=refer_uploader> <div data-bind=\"visible: !readOnly()\"> <span>请上传原件、电子彩色扫描件或照片，要求文件完整、字迹清晰、图片方向正确</span> </div> <filesupload params=\"filesize: fileSize, basic: $root.id, groupname: groupname(), callbackDatas: callback,\n    readonly: readOnly, id: id, index: index, enterpriseId: enterpriseId\"></filesupload> <input id=successId type=text style=display:none> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/uploader/index.html
// module id = 408
// module chunks = 144